import React from 'react';
import classnames from 'classnames';
import {
  withRipple,
  InjectedProps,
} from '@material/react-ripple';

import {CSS_CLASSES} from './constant';

export interface PrimaryContentBaseProps
  extends React.HTMLProps<HTMLDivElement>,
    InjectedProps<HTMLDivElement> {
  className: string;
  unbounded?: boolean;
}

export const PrimaryContentBase: React.FunctionComponent<
  PrimaryContentBaseProps
> = ({
  className = '',
  initRipple,
  children,
  unbounded,
  ...otherProps
}) => {
  const classes = classnames(CSS_CLASSES.PRIMARY_ACTION, className);

  return (
    <div className={classes} ref={initRipple} {...otherProps}>
      {children}
    </div>
  );
};

export default withRipple<PrimaryContentBaseProps, HTMLDivElement>(
  PrimaryContentBase
);
